<template>
  <span class="icon-calibration-sequence">
    <IconMaterial title="group_work" :size="size" />
    <span class="icon-calibration-sequence__letter">с</span>
  </span>
</template>

<script>
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'IconCalibrationSequence',

    components: {
      IconMaterial,
    },

    props: {
      size: {
        type: Number,
        default: 16,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-calibration-sequence {
    position: relative;

    &__letter {
      position: absolute;
      bottom: 1px;
      right: -2px;
      color: black;
      background-color: rgb(255, 255, 255);
      line-height: 6px;
      padding: 1px 1px 3px 1px;
      border-radius: 2px;
      color: $color-text-primary;
    }
  }
</style>
